import ShiftsTable from "./ShiftsTable";

export default ShiftsTable